exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".point-content-justify .day-info{display:flex;justify-content:space-between}.point-content-justify .day-info p{font-size:16px}@media screen and (max-width:1242px) and (min-width:1200px){.point-content-justify{min-height:225px!important}}.justify-he{background:var(--yellowWithText);color:#fff;border-radius:4px;padding:3px 9px;font-size:12px;line-height:20px;text-align:center}.txt-info{position:absolute;top:8px;left:230px}@media only screen and (max-width:460px){.txt-info{position:absolute;top:-25px;left:16px}}.date-change-history{width:200px!important}.date-change-history .remove-date-icon{color:var(--textSide)!important}.date-history-point{top:-1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0bcd8578","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/views/restricted/pointHistory/PointHistory.vue
// module id = 1082
// module chunks = 0